import React, { useState, useEffect } from 'react';

import DialogContent from '@material-ui/core/DialogContent';
import { Dialog } from '@material-ui/core';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/close-black.svg';
import styles from './requestModal.module.css';
import Form from './Form';
import PreCancelDialog from './PreCancelDialog';
import { successToast } from '../toast';

const RequestUpdateModal = ({ item, open, setOpen }) => {
  const [localItem, setLocalItem] = useState({});
  const [errors, setErrors] = useState({});
  const [isOpenPreCancel, setIsOpenPreCancel] = useState(false);

  useEffect(() => {
    if (open && item) {
      setLocalItem({ ...item, type: 'Certification' });
      setErrors({});
    }
  }, [open, item]);

  const handleLocalChange = (field, value) => {
    if (value === undefined) {
      return;
    }

    setLocalItem((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    setOpen(false);

    successToast('Request submitted for review');
  };

  const handleClose = () => {
    setIsOpenPreCancel(false);
    setOpen(false);
  };

  return (
    <>
      <PreCancelDialog
        isOpen={isOpenPreCancel}
        setIsOpen={setIsOpenPreCancel}
        onDismiss={() => setIsOpenPreCancel(false)}
        handleClose={handleClose}
      />
      <Dialog
        style={{ overflow: 'visible', padding: 18 }}
        open={open}
        classes={{
          root: styles.popupRoot,
          paper: styles.popupContainer,
        }}
        BackdropProps={{
          classes: {
            root: styles.backDrop,
          },
        }}
        keepMounted
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <div style={{ position: 'relative', marginBottom: 16 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <p style={{ fontSize: 26, fontWeight: 600 }}>Request an update</p>
            <p style={{ fontSize: 12, fontWeight: 400, color: '#718096' }}>
              Submit education for HR review. You’ll be notified once your request is processed.
              Please make sure all fields are correct.
            </p>
          </div>

          <CloseIcon
            style={{
              position: 'absolute',
              top: 10,
              right: 0,
              cursor: 'pointer',
              width: 15,
              height: 15,
            }}
            onClick={() => setOpen(false)}
            fill="#718096"
          />
        </div>

        <DialogContent style={{ overflow: 'visible', padding: 0 }}>
          <Form
            item={localItem}
            onChange={handleLocalChange}
            errors={errors}
            setErrors={setErrors}
            isDisabled={false}
          />

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button
              className="btn_cancel rounded-md"
              type="button"
              onClick={() => setIsOpenPreCancel(true)}
            >
              Cancel
            </button>
            <button className="btn_my_cv rounded-md px-3" type="button" onClick={handleSubmit}>
              Submit for review
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RequestUpdateModal;
